import { render } from "./ReviewReports.vue?vue&type=template&id=d29a2290&scoped=true"
import script from "./ReviewReports.vue?vue&type=script&lang=js"
export * from "./ReviewReports.vue?vue&type=script&lang=js"

import "./ReviewReports.vue?vue&type=style&index=0&id=d29a2290&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d29a2290"]])

export default __exports__